
import { TextField } from "@material-ui/core";
import * as React from "react";
import {Link} from "react-router-dom";

export interface MetricsValuePanelProps {
    header:string;
    mainTitle:string;
    subTitle:string;
    mainValue:any;
    subValue?:any;
    currency?: string;
    type:string;
    metricPanelSize?:string;
    color?:string;
    navTo?:string;
    listRequest?: any;
    onClick?: () => void;
}

export class MetricsValuePanel extends React.Component<MetricsValuePanelProps> {

    //Move to its own component when finished.
    renderIcon(type:string, value?:number) {
        // eslint-disable-next-line no-self-assign
        value === undefined ? value = 0 : value = value;
        if(type === "LOGIN") {
            return(
                <div className="avatar-lg rounded-circle bg-soft-blue border-blue border" style={{marginTop:"15px"}}>
                    <i className="fe-users font-22 avatar-title text-blue"></i>
                </div>
            )
        } else if(type === "DEPOSIT"){
            if(this.props.color==="GREEN"){
                return(
                    <div className="avatar-lg rounded-circle bg-soft-success border-success border" >
                        <i className="far fa-credit-card font-22 avatar-title text-success"></i>
                    </div>
                );
            }
            return(
                <div className="avatar-lg rounded-circle bg-soft-warning border-warning border" style={{marginTop:"15px"}}>
                    <i className="far fa-credit-card font-22 avatar-title text-warning"></i>
                </div>
            );
        } else if(type === "REVENUE"){
            return(
                <div className="avatar-lg rounded-circle bg-soft-success border-success border" style={{marginTop:"15px"}}>
                    <i className="fas fa-dollar-sign font-22 avatar-title text-success"></i>
                </div>
            );
        }
        else if(type === "WITHDRAW"){
            if(this.props.color==="RED"){
                return(
                    <div className="avatar-lg rounded-circle bg-soft-danger border-danger border" >
                        <i className="far fa-credit-card font-22 avatar-title text-danger"></i>
                    </div>
                );
            }
            return(
                <div className="avatar-lg rounded-circle bg-soft-warning border-warning border" style={{marginTop:"15px"}}>
                    <i className="far fa-credit-card font-22 avatar-title text-warning"></i>
                </div>
            );
        }
        else if(type === "BONUS"){
            if(this.props.color==="YELLOW"){
                return(
                    <div className="avatar-lg rounded-circle bg-soft-warning border-warning border">
                        <i className="fas fa-dollar-sign font-22 avatar-title text-warning"></i>
                    </div>
                );
            }
            return(
                <div className="avatar-lg rounded-circle bg-soft-success border-success border" style={{marginTop:"15px"}}>
                    <i className="fas fa-dollar-sign font-22 avatar-title text-success"></i>
                </div>
            );
        }
        else if(type === "PENDING"){
            if(this.props.color==="BLUE"){
                return(
                    <div className="avatar-lg rounded-circle bg-soft-info border-info border">
                        <i className="fas fa-question font-22 avatar-title text-info"></i>
                    </div>
                );
            }
            return(
                <div className="avatar-lg rounded-circle bg-soft-success border-success border" style={{marginTop:"15px"}}>
                    <i className="fas fa-question font-22 avatar-title text-success"></i>
                </div>
            );
        }
    }

    getMetricPanelSize():any{
       if (this.props.metricPanelSize === undefined) {
            return "col-md-6 col-xl-3";
       }else{
            return this.props.metricPanelSize;
       }
    }

    render() {
        if(this.props.navTo && this.props.listRequest){
            return(
                <div className={this.getMetricPanelSize()}>
                    <div className="widget-rounded-circle card-box">
                    <Link to={{
                        pathname: this.props.navTo,
                        state: {
                            listRequest: this.props.listRequest,
                            lookupExpanded: true
                        }
                    }} >
                        <div className="row">
                            <div className="col-6">
                                <div className="text-left">
                                    <h3 className="text-muted mt-1">{this.props.header}</h3>
                                    {this.renderIcon(this.props.type,Number(this.props.mainValue))}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="text-right">
                                    <h3 className="text-dark mt-1"><TextField value={this.props.mainValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h3>
                                    <p className="text-muted mb-1 text-truncate">{this.props.mainTitle}</p>
                                </div>
                                <div className="text-right" style={{marginTop:"25px"}}>
                                    <h5 className="text-dark mt-1"><TextField value={this.props.subValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h5>
                                    <small className="text-muted mb-1 text-truncate">{this.props.subTitle}</small>
                                </div>
                            </div>
                        </div>
                    </Link>
                    </div>
                </div>
            )
        }else if(this.props.onClick){
            return(
                <div className={this.getMetricPanelSize()}>
                    <a onClick={this.props.onClick}>
                        <div className="widget-rounded-circle card-box">
                            <div className="row">
                                <div className="col-6">
                                    <div className="text-left">
                                        <h3 className="text-muted mt-1">{this.props.header}</h3>
                                        {this.renderIcon(this.props.type,Number(this.props.mainValue))}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="text-right">
                                        <h3 className="text-dark mt-1"><TextField value={this.props.mainValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h3>
                                        <p className="text-muted mb-1 text-truncate">{this.props.mainTitle}</p>
                                    </div>
                                    <div className="text-right" style={{marginTop:"25px"}}>
                                        <h5 className="text-dark mt-1"><TextField value={this.props.subValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h5>
                                        <small className="text-muted mb-1 text-truncate">{this.props.subTitle}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            )
        } else {
            return(
                <div className={this.getMetricPanelSize()}>
                    <div className="widget-rounded-circle card-box">
                        <div className="row">
                            <div className="col-6">
                                <div className="text-left">
                                    <h3 className="text-muted mt-1">{this.props.header}</h3>
                                    {this.renderIcon(this.props.type,Number(this.props.mainValue))}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="text-right">
                                    <h3 className="text-dark mt-1"><TextField value={this.props.mainValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h3>
                                    <p className="text-muted mb-1 text-truncate">{this.props.mainTitle}</p>
                                </div>
                                <div className="text-right" style={{marginTop:"25px"}}>
                                    <h5 className="text-dark mt-1"><TextField value={this.props.subValue} disabled={true}/><small className="text-muted"> {this.props.currency ? this.props.currency : " "}</small></h5>
                                    <small className="text-muted mb-1 text-truncate">{this.props.subTitle}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}